import React from 'react'
import { useSelector } from 'react-redux'
import LeieSearchView from 'components/QuickSearch/LEIE/LeieSearchView'

const LeieTabContent = ({ applicantId }) => {
    // Pull business + owners from the already-loaded application. Exposed to the search
    // form as "prefill targets" so the user picks whether to search for the business or
    // an individual owner.
    const businessName = useSelector(state => state?.applicant?.applicantById?.business?.name)
    const owners = useSelector(state => state?.applicant?.applicantById?.owners) || []

    const prefillTargets = {
        business: businessName || null,
        owners: owners
            .filter(o => o?.firstName || o?.lastName)
            .map(o => ({
                firstName: o.firstName || '',
                lastName: o.lastName || '',
                label: [o.firstName, o.lastName].filter(Boolean).join(' ') || 'Owner'
            })),
    }

    return (
        <LeieSearchView
            isQuickSearch={false}
            applicantId={applicantId}
            prefillTargets={prefillTargets}
        />
    )
}

export default LeieTabContent
